import BossModel from "@/models/BossModel";
import PublicImage from "@/models/PublicImage/PublicImage";

export default class Image extends BossModel {

    /**
     *
     * @type {string}
     */
    static apiUrl = 'website-product/image';

    /**
     *
     * @type {string}
     */
    static entity = 'websiteProductImages';

    static fields() {
        return {
            id: this.number(null).nullable(),
            sort_order: this.number(null).nullable(),
            website_product_id: this.number(null).nullable(),
            public_image_id: this.number(null).nullable(),
            created_at: this.attr(null),
            updated_at: this.attr(null),
            publicImage: this.belongsTo(PublicImage, 'public_image_id'),
        }
    }

    /**
     *
     * @returns {boolean|*}
     * @constructor
     */
    PublicImage() {
        return this.getRelated('publicImage');
    }

}
